import * as React from "react";
import dateFormat from "dateformat";
import "./styles.scss";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import headers from "../../config/headers";
import url from "../../url.json";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Skeleton } from "antd";

function Xronology({ t }) {
  const lan = useSelector((state) => state.langReducer);
  const [searchParams] = useSearchParams();
  const [datas, setDatas] = React.useState();
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  React.useEffect(() => {
    axios
      .get(url.url + `/chronologies/${searchParams.get("id")}`, {
        headers: headers(),
      })
      .then((res) => {
        setDatas(res.data.data);
      })
      .catch(() => setDatas([]));
  }, [lan]);

  // oxirgi bajarilgan bosqich — "joriy"
  const lastDone = (datas || []).reduce(
    (acc, res, i) => (res.key == "stages" && res.date ? i : acc),
    -1
  );

  return (
    <div className="chr">
      <h3 className="chr__title">
        <i className="bx bx-git-commit" />
        {t("Chronological information")}
      </h3>
      {!datas ? (
        <Skeleton active paragraph={{ rows: 6 }} />
      ) : (
        <ol className="chr__list">
          {datas.map((res, i) => {
            const isStage = res.key == "stages";
            const state = !isStage
              ? "note"
              : i === lastDone
              ? "current"
              : res.date
              ? "done"
              : "pending";
            return (
              <li key={i} className={`chr__item chr__item--${state}`}>
                <span className="chr__dot">
                  {state === "done" ? (
                    <i className="bx bx-check" />
                  ) : isStage ? (
                    res.sort_number
                  ) : (
                    <i className="bx bx-message-square-detail" />
                  )}
                </span>
                <div className="chr__body">
                  <div className="chr__head">
                    <strong>{isStage ? res.stage?.name : res.department?.name}</strong>
                    {res.date ? <time>{dateFormat(res.date, "dd.mm.yyyy")}</time> : ""}
                  </div>
                  {isStage && res.department?.name ? (
                    <span className="chr__dept">{res.department.name}</span>
                  ) : (
                    ""
                  )}
                  {res.message ? <p className="chr__msg">{res.message}</p> : ""}
                </div>
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
}
export default withTranslation()(Xronology);
